import React from 'react';
import RequestService from './pages/RequestService';
import RequestMatch from './pages/RequestMatch';
import { Route, Redirect } from 'react-router-dom';

// modules return fragments containing routes.
// passing the component as a prop ensures match params are passed in props
// see https://stackoverflow.com/questions/46197178/cannot-read-property-params-of-undefined-react-router-4

const routes = () => {
  return [
    <Route key="/requestservice" exact path="/requestservice/:itemType/:slug" component={RequestService}/>,
    <Route key="/requestmatch" exact path="/requestmatch" component={RequestMatch}/>,
    // handle facebook campaign launched with wrong URL, targetting /match instead of /requestmatch
    <Route key="/match" exact path="/match" render={(props) => <Redirect to={`/requestmatch${props.location.search}`}/>}/>,
  ];
};

export default routes;
